import {
  EMBARGO_VALIDATION_TYPES,
  EMPTY_EMBARGO_CONFIG,
} from './constants';
import { EMBARGO_PICKUP_MANAGEMENT_RULES } from './rules/registry';
import type {
  EmbargoConfig,
  EmbargoRuleEvaluator,
  EmbargoValidationContext,
  EmbargoValidationResult,
  EmbargoViolation,
} from './types';

type ValidateEmbargoOptions = {
  context: EmbargoValidationContext;
  config: EmbargoConfig | null | undefined;
  rules?: EmbargoRuleEvaluator[];
};

const isErrorViolation = (violation: EmbargoViolation): boolean =>
  violation.validationType === EMBARGO_VALIDATION_TYPES.ERROR;

const isWarningViolation = (violation: EmbargoViolation): boolean =>
  violation.validationType === EMBARGO_VALIDATION_TYPES.WARNING;

export const validateEmbargo = ({
  context,
  config,
  rules = EMBARGO_PICKUP_MANAGEMENT_RULES,
}: ValidateEmbargoOptions): EmbargoValidationResult => {
  const embargoConfig = config ?? EMPTY_EMBARGO_CONFIG;

  const shipmentHits = rules.flatMap((rule) => rule.evaluate(context, embargoConfig));
  const shipmentViolations = shipmentHits.filter(isErrorViolation);
  const shipmentWarnings = shipmentHits.filter(isWarningViolation);

  return {
    shipmentViolations,
    shipmentWarnings,
    isBlocked: shipmentViolations.length > 0,
  };
};
